import React, { useState } from "react";
import ChatPanel from "./ChatPanel";
import "../../css/chat.css";

const ChatButton = () => {
    const [open, setOpen] = useState(false);

    return (
        <>
            {open && <ChatPanel />}
            <button className="chat-fab" onClick={() => setOpen(prev => !prev)} title="עוזר קניות">
                {open ? "✕" : "💬"}
            </button>
        </>
    );
};

export default ChatButton;
